export enum CalculatorType {
  Stratifie = 'stratifie',
  // Peinture = 'peinture',
}

interface CalculatorCategoryMapping {
  type: CalculatorType;
  categoryIds: string[];
}

const REGISTRY: CalculatorCategoryMapping[] = [
  { type: CalculatorType.Stratifie, categoryIds: ['cat_id_3241'] },
];

export function getCalculatorType(productCategoryIds: string[]): CalculatorType | null {
  for (const entry of REGISTRY) {
    if (productCategoryIds.some(id => entry.categoryIds.includes(id))) {
      return entry.type;
    }
  }
  return null;
}
